module.exports = __webpack_public_path__ + "static/media/calculator.506396ad.jpg";